/**
 * Created by elad on 22 מרץ 2017.
 */
import * as axios from "axios";

let $router = null;
let $baseUrl = "api";
export const setRouter = (router) => {
  $router = router;
};
export const setBaseUrl = (path) => {
  $baseUrl = path;
    myAxios.defaults.baseURL = path;
};
const myAxios = axios.create({
  baseURL: "/api/",
});
myAxios.interceptors.request.use(function (request) {
  // request.baseURL = "/" + $baseUrl + "/";
  return request;
});
myAxios.interceptors.response.use(function (response) {
    if (response.redirect) {
        $router.replace(response.redirect);
        return;
    }

  return response;
}, function (error) {
  window.ee = error;
  // Do something with response error
  const response = error.response;
  if (response && response.status == 401) {
    // TODO go to login page
    if ($router) {
      $router.replace({ name: "login-page" });
    }
  } else {
    // TODO ALERT ERROR;
  }
  return Promise.reject(error);
});
window.ax = myAxios;
export default myAxios;
